import config from '../../config/config';
export const msalConfig = {
  auth: {
    clientId: config.AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${config.AZURE_TENANT_ID}`,
    // redirectUri: `${config.API_WEB_URL}`
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

// For Microsoft Graph API (basic user info)
export const loginRequest = {
  scopes: ["User.Read"],
};

// For your custom API (replace <your-app-client-id> with your API's client ID)
export const apiRequest = {
  scopes: [`api://${config.AZURE_CLIENT_ID}/access_as_user`],
};